<template>
  <div class="row justify-content-center">
    <div class="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
      <innerHeaderDiy />
      <PaymentStatusPage />
    </div>
  </div>
</template>

<script>
import PaymentStatusPage from '@/components/PaymentStatusPage.vue';
import innerHeaderDiy from '@/components/header/innerHeaderDiy';

export default {
  name: 'PaymentStatusView',
  components: {
    PaymentStatusPage,
    innerHeaderDiy,
  },
};
</script>
